import React from 'react';
import './tooltip.css';

const Tooltip = ({ text, children }) => (
  <div className="tooltip-wrapper">
    {children}
    <div className="tooltip-text">{text}</div>
  </div>
);

export default Tooltip;
